import React from "react"
import {Navigate, RouteObject} from "react-router-dom"

import Check from "@auth/containers/Check"
import AppPanel from "./containers/AppPanel"
import {AdminPanel, adminRoutes, Dashboard, HowToPlay} from "./containers"
import GameContainer from "@modules/gamePlay/containers/GameContainer"
import GamePlayResults from "@modules/gamePlay/containers/GamePlayResults"
import {HighScores, Profile, UserStats} from "@modules/user/containers"
import AdminOnly from "@auth/hoc/AdminOnly"


const routes: Record<string, RouteObject> = {
    check: {
        id: "check",
        path: "/check",
        handle: {
            title: "Checking...",
            hidden: true
        },
        element: <Check/>
    },
    dashboard: {
        id: "dashboard",
        handle: {
            title: "Dashboard",
        },
        path: "/",
        element: <Dashboard/>
    },
    play: {
        id: "play",
        handle: {
            title: "Play",
            hidden: true
        },
        path: "/play/:gameId",
        element: <GameContainer/>
    },
    results: {
        id: "results",
        handle: {
            title: "Results",
            hidden: true
        },
        path: "/results/:gamePlayId",
        element: <GamePlayResults/>
    },
    userStats: {
        id: "userStats",
        handle: {
            title: "Your Stats",
        },
        path: "/stats",
        element: <UserStats/>
    },
    highScores: {
        id: "highScores",
        handle: {
            title: "Leaderboard",
        },
        path: "/leaderboard",
        element: <HighScores/>
    },
    howToPlay: {
        id: "howToPlay",
        handle: {
            title: "How To Play",
        },
        path: "/how",
        element: <HowToPlay/>
    },
    profile: {
        id: "profile",
        path: "/profile",
        element: <Profile/>,
        handle: {
            title: "Profile",
            hidden: true
        },
    },
    admin: {
        id: "admin",
        handle: {
            title: "Admin Panel",
            hidden: true
        },
        path: "/admin",
        element: <AdminOnly>
            <AdminPanel/>
        </AdminOnly>,
        children: [{
            path: "",
            element: <Navigate to="/admin/gamePlays" replace={true}/>,
        }, ...adminRoutes]
    }
}

export const mainRoutes: RouteObject[] = [
    {
        path: "/",
        element: <AppPanel/>,
        children: Object.values(routes)
    }
]

export function navRoutes(isAdmin: boolean) {

    const nav = Object.values(routes || {}).filter(x => !x.handle?.hidden)
    if (isAdmin) {
        nav.push(routes.admin)
    }

    return nav
}

export const userRoutes = [routes.profile]



